import { render, staticRenderFns } from "./ShopAddressList.vue?vue&type=template&id=6617ead6&scoped=true&lang=pug&"
import script from "./ShopAddressList.vue?vue&type=script&lang=ts&"
export * from "./ShopAddressList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6617ead6",
  null
  
)

export default component.exports